<template>
    <section id="bailes">
        <Banner/>
    </section>
</template>

<script>

import Banner from './components/Banner'

export default {
    name: 'Bailes',
    components: {
        Banner
    }
}
</script>

<style lang="sass">
    #bailes
        width: 100vw
</style>
